
function LabelledMultilineInput ( { id, label, value, error, onChange, type, editable, onBlur } )
{
    return  <div className="py-2">
                <label htmlFor={id}>{label} {error}</label>
                <textarea id={id} value={value} type={type} onChange={ ( e ) => onChange ( e.target.value ) } disabled={editable === false} onBlur={ onBlur ? () => onBlur () : null } rows={10} className="w-full" />
            </div>
}

export default LabelledMultilineInput;